var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSquareDelete24Px(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efebf6;}.cls-2{fill:#7644c9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "btn-graphic_small_surface",
    "data-name": "btn-graphic small surface",
    className: "cls-1",
    width: 24,
    height: 24,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_221",
    "data-name": "Trazado 221",
    className: "cls-2",
    d: "M7.84,16.85a1.39,1.39,0,0,0,1.39,1.38h5.54a1.39,1.39,0,0,0,1.39-1.38V9a.3.3,0,0,0-.3-.3H8.14a.3.3,0,0,0-.3.3Zm8.79-9H7.37a.54.54,0,0,1-.54-.54V7a.54.54,0,0,1,.54-.55h9.26a.54.54,0,0,1,.54.55V7.3A.54.54,0,0,1,16.63,7.84Zm-2-.85H9.35a.22.22,0,0,1-.23-.22l1-.94a.69.69,0,0,1,.42-.22h2.94a.7.7,0,0,1,.4.22l1,.94A.22.22,0,0,1,14.65,7Zm-3.59,8.63a.43.43,0,1,1-.85,0v-4.3a.43.43,0,1,1,.85,0Zm2.73,0a.43.43,0,1,1-.85,0v-4.3a.43.43,0,1,1,.85,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSquareDelete24Px);
export default __webpack_public_path__ + "static/media/ic_square-delete_24px.cdab803bce9939b6292c9d1f7cfc954b.svg";
export { ForwardRef as ReactComponent };